import { Subject, takeUntil } from 'rxjs';
import { Component, EventEmitter, Output, ChangeDetectionStrategy, DestroyRef, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { HttpService, MessageService, UserService } from 'src/app/core';
import { PathConfig } from 'src/app/core/config/path.config';
import { UserInfo } from 'src/app/core/models/user/user-info.model';
import { Utility } from 'src/app/core/utils/utility';
import { EmailValidator } from 'src/app/core/validators';
import { ConfirmModalComponent } from 'src/app/shared/components/confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-update-email',
  templateUrl: './update-email.component.html',
  styleUrl: './update-email.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UpdateEmailComponent {
  private readonly destroy$ = new Subject<void>();

  private readonly destroyRef = inject(DestroyRef);

  updateForm!: UntypedFormGroup;
  disableSubmit: boolean = true;
  show = {
    verifyNewEmail: true,//verified new email msg/ and its input readonly when verified/verify new email/verify new email otp
    verifyOldEmailOTP: true,//verify old email and update to new email/update email btn
    oldEmailOTPfield: false,
    newEmailOTPfield: false
  }
  countdown: number = 60;
  timer: any;
  @Output() onEmailChanged: EventEmitter<boolean> = new EventEmitter();
  messageData: {
    errorArr: string[],
    verified: string | null
  } = {
      errorArr: [],
      verified: null
    };
  redirectData = {
    message: '',
    countdown: 10,
    timer: null as any as ReturnType<typeof setInterval>
  };
  config:any;
  userInfo: any;
  confirmation_id:any;
  constructor(
    private fb: UntypedFormBuilder,
    private httpService: HttpService,
    public modalService: NgbModal,
    private translateService: TranslateService,
    private userService: UserService,
    private msgService: MessageService
  ) {
    this.translateService.setDefaultLang('en');
    this.translateService.use(localStorage.getItem('Selected_Language') || 'en');
  }

  ngOnInit(): void {
    this.config = Utility.getOTPConfig();
    this.updateForm = this.fb.group({
      old_email: new UntypedFormControl('', [Validators.required, EmailValidator]),
      new_email: new UntypedFormControl('', [Validators.required, EmailValidator]),
      old_email_otp: new UntypedFormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]),
      new_email_otp: new UntypedFormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]),
    });
    this.updateForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.messageData.errorArr = [];
      this.messageData.verified = null;
    });
    this.userInfo = this.userService.getUserInfo();
  }

  onSubmit(): void {//verify old email and otp and change to new email
    if (this.updateForm.valid) {
      const param = {
        email: this.updateForm?.value?.old_email,
        code: this.updateForm?.value?.old_email_otp,
        confirmation_id: this.confirmation_id
      };
      this.httpService.put(PathConfig.CONFIRM_OLD_EMAIL, param).subscribe({
        next: (response) => {
          this.messageData.errorArr = [];
          // this.messageData.verified = response.message;
          // this.updateForm.reset();
          // this.redirectData.message = ` ${this.translateService.instant('You will be redirected to login')} `;
          // if (this.redirectData?.timer) {
          //   clearInterval(this.redirectData?.timer);
          // };
          // this.redirectData.countdown = 10;
          // this.redirectData.timer = setInterval(() => {
          //   this.redirectData.countdown--;
          //   if (this.redirectData.countdown === 0) {
          //     clearInterval(this.redirectData.timer);
          //     this.modalService.dismissAll();
          //     this.onEmailChanged.emit(true);
          //   }
          // }, 1000);
          this.getMeDetail();
          this.msgService.showSuccess(response.message);
          this.modalService.dismissAll();
        },
        error: (err) => {
          this.showErrorInModal(err);
        }
      });
    }
  }

  getOTP(from?: string) {//for new & old email
    if (!from) {
      if (!this.updateForm.get('new_email')?.valid || !this.updateForm.get('old_email')?.valid) {
        return;
      }
      const param = { email: this.updateForm?.value?.new_email, old_email: this.updateForm?.value?.old_email };
      this.httpService.put(PathConfig.UPDATE_EMAIL, param)
        .subscribe((response) => {
          this.confirmation_id = response?.confirmation_id;
          if (this.userInfo?.enable_2fa == 'NO') {
            this.getMeDetail();
            this.modalService.dismissAll();
            this.msgService.showSuccess(response.message);
          } else {
            this.show.oldEmailOTPfield = true;
            this.show.verifyOldEmailOTP = false;
            this.messageData.errorArr = [];
            this.messageData.verified = response.message;
            this.startCountdown();
          }
        }, (err) => {
          this.countdown = 0;
          this.showErrorInModal(err);
        });
    } else {
      const newEmail = this.updateForm.get('new_email')?.value;
      const oldEmail = this.updateForm.get('old_email')?.value;
      if (
        !this.updateForm.get('new_email')?.valid ||
        !this.updateForm.get('old_email')?.valid ||
        newEmail === oldEmail
      ) {
        return;
      }
      const param = { email: this.updateForm?.value?.new_email, old_email: this.updateForm?.value?.old_email };
      this.httpService.put(PathConfig.VERIFY_NEW_EMAIL, param)
        .subscribe((response) => {
          this.confirmation_id = response?.confirmation_id;
          this.show.newEmailOTPfield = true;
          this.messageData.errorArr = [];
          this.messageData.verified = response.message;
          this.startCountdown();
        }, (err) => {
          this.countdown = 0;
          this.showErrorInModal(err);
        });
    }
  }

  startCountdown() {
    this.countdown = 60;
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.timer = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        clearInterval(this.timer);
      }
    }, 1000);
  }

  verifyNewEmailOTP() {
    if (!this.updateForm.get('new_email_otp')?.valid || !this.updateForm.get('new_email')?.valid) {
      return;
    }
    const param = { 
      code: this.updateForm?.value?.new_email_otp, 
      email: this.updateForm?.value?.new_email,
      confirmation_id: this.confirmation_id
    };
    this.httpService.put(PathConfig.CONFIRM_NEW_EMAIL, param)
      .subscribe(() => {
        if (this.userInfo?.enable_2fa == 'YES') {
          this.show.verifyNewEmail = false;
          this.show.newEmailOTPfield = false;
          this.messageData.errorArr = [];
          this.messageData.verified = '';
        }
        this.getOTP();
      }, (err) => {
        this.showErrorInModal(err);
      });
  }

  showErrorInModal(err: any) {
    this.messageData.errorArr = [];
    this.messageData.verified = '';
    if (err?.error?.message) {
      this.messageData.errorArr = Utility.getErrorList(err?.error) ?? [];
    } else {
      this.messageData.errorArr = ['Server Error, Please try again after some time.'];
    }
  }

  dismissModal() {
    if (this.updateForm.dirty) {
      const modalRef = this.modalService.open(ConfirmModalComponent, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
        size: 'sm',
      });
      modalRef.componentInstance.confirmationMessage =
        `${this.translateService.instant('Are you sure you want to close?')}`;
      modalRef.result.then((response) => {
        if (response) {
          this.modalService.dismissAll(this.redirectData.message ? 'logout' : 'no-logout');
        }
      });
    } else {
      this.modalService.dismissAll(this.redirectData.message ? 'logout' : 'no-logout');
    }
  }

  getMeDetail() {
    this.httpService.get(PathConfig.USER_ME).subscribe((response) => {
      this.userService.setUserInfo(new UserInfo(response.user));
    }, (err) => { });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.timer) {
      clearInterval(this.timer);
    };
    if (this.redirectData?.timer) {
      clearInterval(this.redirectData?.timer);
    };
  }

}
